exports.download = require('./lib/wget').download;
exports.request = require('./lib/wget').request;


//////////////////
// WEBPACK FOOTER
// ./~/wget-improved/index.js
// module id = 2019
// module chunks = 0 1